import { Icon } from "./Icon.tsx";

/** "Simulation Summary" icon — a small bar-chart glyph. */
export function SummaryIcon() {
  return (
    <Icon>
      <path d="M5 20V10M12 20V4M19 20v-7" />
    </Icon>
  );
}
